import isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

class ResourcesGrid {
    constructor($el = []) {
        this.$el = $el;

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$resources = this.$el.find('.resource');
        this.$resourcesGrid = this.$el.find('.resources-grid__posts');
        this.$resourcesGridLoadMore = this.$el.find('.resources-grid__load-more');

        this.isBusy = false;
        this.loadMoreOffset = null;
        this.loadedElementIndex = 0;
        this.busyClass = 'resources-grid__load-more--loading';

        if(this.$resources.length && this.$resourcesGrid.length) {
            this._createGrid();
            this._refreshLoadMoreOffset();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onLoadMoreDoneFn = this._onLoadMoreDone.bind(this);
        this.onLoadMoreFailFn = this._onLoadMoreFail.bind(this);
        this.lockLoadingFn = this._lockLoading.bind(this);
        this.unlockLoadingFn = this._unlockLoading.bind(this);
        this.checkIfLoadMoreIsReachedFn = this._checkIfLoadMoreIsReached.bind(this);
        this.refreshGridLayoutFn = this._refreshGridLayout.bind(this);
        this.onImageLoadedFn = this._onImageLoaded.bind(this);

        $(window).on('scroll', this.checkIfLoadMoreIsReachedFn);
    }

    _createGrid() {
        this.grid = this.$resourcesGrid.isotope({
            itemSelector: '.resource',
            layoutMode: 'masonry',
            masonry: {
                columnWidth: '.resources-grid__column-sizer',
                gutter: '.resources-grid__gutter-sizer',
                horizontalOrder: true
            },
            transitionDuration: 0,
            /*getSortData: {
                date: '[data-date]'
            },
            sortBy: ['date'],
            sortAscending: false,*/
            percentPosition: true
            // stagger: 30
            // transitionDuration: 4000,
            // hiddenStyle: {
            //     opacity: 0
            // },
            // visibleStyle: {
            //     opacity: 1
            // }
        });
        
        this.grid.imagesLoaded({ background: '.resource' })
            .progress((instance, el) => {
                this.loadedElementIndex ++;
                this.refreshGridLayoutFn();
                this.onImageLoadedFn(el);
            })
            .always(() => {
                this.loadedElementIndex = 0;
                this.refreshGridLayoutFn();
            });
    }

    _loadResources() {
        if(!this.isBusy) {
            const request = $.ajax({
                url: caue.ajaxUrl,
                type: 'post',
                data: this._getRequestData(),
                beforeSend: this.lockLoadingFn
            });
            request.done(this.onLoadMoreDoneFn);
            request.fail(this.onLoadMoreFailFn);
            request.always(this.unlockLoadingFn);
        }
    }

    _onImageLoaded(el) {
        const $el = $(el.element);
        
        $el
            .css({
                '-webkit-animation-delay': `${this.loadedElementIndex * 0.04}s`,
                '-moz-animation-delay': `${this.loadedElementIndex * 0.04}s`,
                '-ms-animation-delay': `${this.loadedElementIndex * 0.04}s`,
                '-o-animation-delay': `${this.loadedElementIndex * 0.04}s`,
                'animation-delay': `${this.loadedElementIndex * 0.04}s`
            })
            .addClass('resource--visible');
    }

    _refreshGridLayout() {
        this.grid.isotope('layout');

        this._refreshLoadMoreOffset();
    }

    _refreshLoadMoreOffset() {
        this.loadMoreOffset = (this.$resourcesGridLoadMore.offset().top - window.innerHeight) + 80;
    }

    _checkIfLoadMoreIsReached() {
        if(window.pageYOffset >= this.loadMoreOffset && !this.busy) {
            const currentPage = parseInt(this.$resourcesGridLoadMore.attr('data-next-page'), 10);
            const maxPage = parseInt(this.$resourcesGridLoadMore.attr('data-max-page'), 10);

            // Check if we haven't reached last page
            if(currentPage <= maxPage) {
                this._loadResources();
            }
        }
    }

    _getRequestData() {
        const formData = {
            action: 'load_more_resources',
            page: this.$resourcesGridLoadMore.attr('data-next-page'),
            category: this.$resourcesGridLoadMore.attr('data-category'),
            theme: this.$resourcesGridLoadMore.attr('data-theme'),
            _wpnonce_resources_loading: caue.resourcesLoadingNonce
        };

        return formData;
    };

    _onLoadMoreDone(response, textStatus, jqXHR) {
        if(response.data.result) {
            // Insert new resources in resources grid after images loading
            const $newResources = $(response.data.result);
            $newResources.imagesLoaded(() => {
                $newResources.each((index, el) => {
                    const $el = $(el);
                    $el.css({
                        '-webkit-animation-delay': `${index * 0.04}s`,
                        '-moz-animation-delay': `${index * 0.04}s`,
                        '-ms-animation-delay': `${index * 0.04}s`,
                        '-o-animation-delay': `${index * 0.04}s`,
                        'animation-delay': `${index * 0.04}s`
                    });
                    $el.addClass('resource--visible');
                });
                this.$resourcesGrid.append($newResources);
                this.$resourcesGrid.isotope('appended', $newResources);

                this._refreshGridLayout();
            });
            
            // Update next page numbers
            this.$resourcesGridLoadMore.attr('data-max-page', response.data.max_page);

            const maxPage = parseInt(this.$resourcesGridLoadMore.attr('data-max-page'), 10);
            const currentPage = parseInt(this.$resourcesGridLoadMore.attr('data-next-page'), 10);

            // Control if there is still pages to load
            if(currentPage <= maxPage) {
                this.$resourcesGridLoadMore.attr('data-next-page', currentPage + 1);
            }
        }
    };

    _onLoadMoreFail(jqXHR, textStatus, errorThrown) {
        console.log('onLoadMoreFail', jqXHR); 
    };

    _lockLoading() {
        this.isBusy = true;
        this.$resourcesGridLoadMore.addClass(this.busyClass);
    };

    _unlockLoading() {
        this.isBusy = false;
        this.$resourcesGridLoadMore.removeClass(this.busyClass);
    };
}

export default ResourcesGrid;
